<template>
    <section data-testid="comparison-versus" class="comparison-versus">
        <h2 v-if="title" data-testid="comparison-versus-title" class="comparison-versus__title">{{ title }}</h2>
        <div v-if="subtitle" data-testid="comparison-versus-subtitle" class="comparison-versus__subtitle">{{ subtitle }}</div>
        <VersusComparisonList :items="items" :left-label="leftColumnLabel" :right-label="rightColumnLabel" />
        <VJoyWrapper justify="center">
            <VJoyButton
                v-if="hasCta"
                :variant="buttonVariant"
                :href="ctaUrl ? $withLocalePrefix(ctaUrl) : undefined"
                rel="nofollow"
                class="comparison-versus__cta"
            >
                {{ ctaLabel }}
            </VJoyButton>
        </VJoyWrapper>
    </section>
</template>
<script setup lang="ts">
    import {computed} from '#imports';
    import {VJoyButton, VJoyWrapper} from '@maltjoy/core-vue';
    import type {ComparisonItem} from './VersusComparisonList.vue';
    import VersusComparisonList from './VersusComparisonList.vue';
    import {useVariants} from '../../composables/useVariants';

    const props = defineProps<{
        title?: string;
        subtitle?: string;
        leftColumnLabel: string;
        rightColumnLabel: string;
        items: ComparisonItem[];
        ctaLabel?: string;
        ctaUrl?: string;
    }>();

    const {button: buttonVariant} = useVariants();

    const hasCta = computed(() => !!props.ctaLabel && !!props.ctaUrl);
</script>
<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .comparison-versus {
        &__title,
        &__subtitle {
            margin: 0 auto;
            text-align: center;
        }

        &__title {
            @include text.getFontBySize(secondary-600);
            color: var(--joy-color-text-title);
            margin-bottom: var(--joy-core-spacing-2);
        }

        &__subtitle {
            @include text.getFontBySize(primary-600);
            color: var(--joy-color-text-body);
            margin-bottom: var(--joy-core-spacing-8);
        }

        &__cta {
            margin-top: var(--joy-core-spacing-10);
        }
    }
</style>
